import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const MFAStyle = makeStyles()((theme: Theme) => ({
  infoContent: {
    fontSize: '16px',
    lineHeight: '32px',
    color: '#1A1A1E',
    marginBlockStart: '0px',
    [theme.breakpoints.down(600)]: {
      lineHeight: '24px',
    },
  },
  verificationInput: {
    '& input:disabled': {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.secondary.main,
    },
    '& fieldset': {
      display: 'none',
    },
  },
  otpContainer: {
    marginTop: '-10px',
    '& .otp-input': {
      fontSize: '2rem',
      width: '48px !important',
      height: '48px !important',
      margin: '10px 5px 20px',
      marginLeft: '0px',
      color: '#F13C00',
      fontWeight: 600,
      border: `1px solid ${theme.palette.grey[500]}`,
      outline: 'none',
      padding: '.2em',
      [theme.breakpoints.between(600, 1024)]: {
        padding: '0px 3px',
        fontSize: '2rem',
      },
      [theme.breakpoints.between(0, 600)]: {
        margin: '10px 3px 20px',
        fontSize: '2rem',
      },
      [theme.breakpoints.between(360, 480)]: {
        padding: '0px 3px',
        fontSize: '1.75rem',
      },
      [theme.breakpoints.between(0, 360)]: {
        width: '36px !important',
        height: '36px !important',
        fontSize: '1.5rem',
      },
    },
    '& .otp-input--focused': {
      border: `2px solid #F13C00`,
    },
  },
  otpModuleBodyContainer: {
    maxWidth: '32em',
    marginTop: '0.5rem',
    [theme.breakpoints.down(600)]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.between(0, 360)]: {
      maxWidth: '275px',
    },
  },
  verificationLabel: {
    lineHeight: '36px',
    fontWeight: 600,
  },
  resendContainer: {
    display: 'flex',
    marginTop: '0.5rem',
    marginBottom: '1.75rem',
  },
  resendInfo: {
    fontSize: '1.1250rem',
    lineHeight: '24px',
    color: '#0269B5',
    fontWeight: 400,
    height: 'fit-content',
    padding: 'unset',
    letterSpacing: 'inherit',
    [theme.breakpoints.down(600)]: {
      fontSize: '16px',
    },
    '&:hover': {
      background: 'none',
    },
    '&.Mui-disabled': {
      color: '#0269b566',
    },
  },
  resendLink: {
    fontSize: '1.1250em',
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: '#FF4500',
    paddingLeft: '8px',
    fontFamily: 'Acronym-Semibold',
    textDecoration: 'underline',
  },
  boxContainer: {
    width: '100%',
  },
  otpContainerContinueBtn: {
    borderRadius: '4px!important',
    fontSize: '18px',
    background: '#F13C00 !important',
    fontWeight: 400,
    borderColor: '#F13C00',
    width: '122px',
    height: '48px',
  },
  otpFormHeader: {
    color: '#1A1A1E',
    fontWeight: 400,
    fontSize: '57px !important',
    [theme.breakpoints.between(0, 360)]: {
      maxWidth: '250px',
      width: '250px',
      fontSize: '20px!important',
      fontWeight: 600,
    },
    [theme.breakpoints.down(600)]: {
      fontSize: '24px !important',
      textAlign: 'left',
      marginBottom: '-10px',
    },
    [theme.breakpoints.between(600, 767)]: {
      fontSize: '40px!important',
    },
    [theme.breakpoints.between(768, 992)]: {
      fontSize: '48px!important',
    },
    lineHeight: '36px',
  },
  mfaContainer: {
    [theme.breakpoints.down(600)]: {
      margin: '3.5em 0.5em',
      width: '100%',
      maxWidth: '100%',
    },
    [theme.breakpoints.between(0, 360)]: {
      maxWidth: '275px',
      width: '275px',
    },
  },
}))

export default MFAStyle
